<template>
  <el-upload
      v-loading="loading"
      :action="qiniu.actionPath"
      :data="qiniu.postData"
      class="upload-one-component"
      :style="{ width: width, height: height }"
      :show-file-list="false"
      :before-upload="beforeUpload"
      :on-success="uploadSuccess"
      :on-error="uploadError"
  >
    <!-- 图片显示 -->
    <img
        v-if="isImage && url"
        :src="url"
        class="upload-one-component-image"
    />

    <!-- 文件名显示 -->
    <div v-else-if="url" class="upload-one-component-file">
      <i class="el-icon-document" style="font-size: 20px; margin-right: 5px;" />
      <span class="filename">{{ fileName }}</span>
    </div>

    <!-- 默认加号 -->
    <i v-else class="el-icon-plus upload-one-component-icon"></i>
  </el-upload>
</template>

<script>
import { getQiniuToken } from "@/api/common";
import { guid } from "@/utils/index";

export default {
  name: "UploadOne",
  props: {
    url: {
      value: ""
    },
    width: {
      type: String,
      default: "120px"
    },
    height: {
      type: String,
      default: "120px"
    }
  },
  model: {
    prop: "url",
    event: "update"
  },
  data() {
    return {
      loading: false,
      qiniu: {
        actionPath: "",
        baseUrl: "",
        postData: {}
      },
      isImage: false,
      fileName: ""
    };
  },
  created() {
    getQiniuToken().then(response => {
      this.qiniu.actionPath = response.data.uploadUrl;
      this.qiniu.baseUrl = response.data.baseUrl;
      if (!this.qiniu.postData.token) {
        this.qiniu.postData.token = response.data.token;
      }
    });
  },
  methods: {
    beforeUpload(file) {
      const isImageFile = file.type.startsWith("image/");
      const ext = file.type.split("/")[1] || "jpg";
      this.isImage = isImageFile;
      this.fileName = file.name || ("文件." + ext);
      this.qiniu.postData.key = guid() + "." + ext;
      this.loading = true;
    },
    uploadSuccess(res) {
      const url = this.qiniu.baseUrl + "/" + res.key;
      this.$emit("update", url);
      this.loading = false;
    },
    uploadError(res) {
      this.loading = false;
      this.$message.error("上传失败：" + res);
    }
  }
};
</script>

<style scoped lang="scss">
.upload-one-component {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  .upload-one-component-icon,
  .upload-one-component-image,
  .upload-one-component-file {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .upload-one-component-image {
    object-fit: cover;
  }

  .upload-one-component-file {
    font-size: 14px;
    color: #606266;
    text-align: center;
    padding: 0 5px;
    word-break: break-all;
  }

  .filename {
    display: inline-block;
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:hover {
    border-color: #409eff;
  }
  ::v-deep(.el-upload) {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
